<h1> REGISTRATION </h1>
<p>
  Participation in the CIFRIS26 Conference is <b>free</b> and open to all current members and to anyone who will join DeCifris. People not able/willing to join De Cifris (e.g., non-EU nationals) are welcome to fill the form specifying their situation: we will admit as many as possible.
</p>
<p style="text-align: center; margin-top: 20px;">
  <a href="https://docs.google.com/forms/d/e/1FAIpQLSft-88LNvjkw2fAliVjxykxrg3Shz-km_db3p_1jvxRwi_v5Q/viewform?usp=publish-editor"
     target="_blank"
     style="display: inline-block; padding: 12px 24px; background-color: var(--cifris_blue); color: white; text-decoration: none; border-radius: 5px; font-weight: bold; font-size: 1.1em;">
     Click here to register for CIFRIS 2026
  </a>
</p>
  
